import { FAVORITE_DELIVERY_TYPES } from 'common/constants';

export { FAVORITE_DELIVERY_TYPES };

export type FavoriteDeliveryType = (typeof FAVORITE_DELIVERY_TYPES)[number];

export type CheckoutClientData = {
  name: string;
  surname: string;
  phone: string;
  email: string;
  inn: string;
  companyName: string;
  customerNumber: string;
};

export type CheckoutAddress = {
  longitude: string;
  latitude: string;
  city: string;
  street: string;
  house: string;
  floor?: string;
  flat?: string;
  precision: string;
  kind: string;
  title: string;
};

export type CheckoutInfo = {
  clientData?: CheckoutClientData;
  deliveryType: FavoriteDeliveryType;
  storeId?: number;
  pointId?: string;
  address?: CheckoutAddress;
};

export const isFavoriteDeliveryType = (value: unknown): value is FavoriteDeliveryType =>
  typeof value === 'string' && FAVORITE_DELIVERY_TYPES.includes(value as FavoriteDeliveryType);
